const PACKAGES_HOMEPAGE = 'https://www.homedepot.com/p/sets';

// Keep original, component-facing names
export const getSeoURL = (productCategory, seo1, seo2, slug, packageId) => {
  const seo1Part = seo1 ? `/${seo1}` : '';
  const seo2Part = seo2 ? `/${seo2}` : '';
  const slugPart = slug ? `/${slug}` : '';
  if (productCategory) {
    return `${PACKAGES_HOMEPAGE}/${productCategory}${seo1Part}${seo2Part}${slugPart}/${packageId}`;
  }
  return `${PACKAGES_HOMEPAGE}/appliances${seo1Part}${seo2Part}${slugPart}/${packageId}`;
};

export const getMetaDescription = (packageName, packageTitle) => {
  if (!packageName || !packageTitle) return '';
  return (
    `Save with our ${packageName} at The Home Depot. `
    + `We have the best prices on the newest ${packageTitle} `
    + 'to breathe new life into the heart of your home.'
  );
};
